// src/config.js
// Base URL for the CACI portal API (same backend as the main portal)
// const BASE_URL = process.env.REACT_APP_BASE_URL || "https://portail.caci.dz";
const BASE_URL =  "https://erp.caci.dz";
// Adresse publique du site (URL canoniques, partage, plan du site)
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://ccma.caci.dz").replace(/\/+$/, "");

// DAJC-specific constants — this sub-site is locked to one category and one service
export const DAJC = {
  CATEGORY_ID: 6,   // Articles category for DAJC
  SERVICE_ID: 5,    // Service (pages) category for DAJC
  EMAIL: "deeaj@caci.dz",
  NAME: "DAJC",
  FULL_NAME_FR: "Direction des Affaires Juridiques et du Contentieux",
  FULL_NAME_AR: "مديرية الشؤون القانونية والمنازعات",
  FULL_NAME_EN: "Directorate of Legal Affairs and Litigation",
};

export default BASE_URL;
